var currentText = 0;

[].slice.call(document.querySelectorAll('section.animating_text')).forEach(function(section) {
	var animatingTextWaypoint = new Waypoint({
		element: section,
		handler: function(direction) {
			setTimeout(function() {
				animateText(section);
			}, (section == section.parentNode.firstElementChild ? 3000 : 0));

			this.destroy();
		},
		offset: '60%'
	});
});

function animateText(section) {
	var spans = section.querySelectorAll('span'),
		current = section.querySelector('.current'),
		sibling = spans[currentText++];

	if(current)
		current.classList.remove('current');

	sibling.classList.add('current');

	if(sibling != spans[spans.length-1]) {
		setTimeout(function() {
			animateText(section);
		}, 2400);
	} 
	else {
		setTimeout(function() {
		[].forEach.call(spans, function(span) {
			span.classList.add('highlight-blue');
		});
	}, 2400);
	}
}